import useApi from "../useApi";

const BASE = "/roles";

/** All roles with their permissions (GET /api/roles). */
export const useRolesList = () => {
  const api = useApi(BASE, {
    method: "GET",
    immediate: true,
    errorMessage: "Failed to fetch roles",
    transformResponse: (res) => (Array.isArray(res) ? res : res?.data ?? []),
  });

  const refetch = async () => {
    try {
      const res = await api.execute();
      return { success: true, data: res };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.message || "Failed to fetch roles",
      };
    }
  };

  return {
    data: api.data ?? [],
    loading: api.loading,
    error: api.error,
    refetch,
  };
};

export const useRoleDetail = (id) => {
  const api = useApi(id ? `${BASE}/${id}` : BASE, {
    method: "GET",
    immediate: !!id,
    errorMessage: "Failed to fetch role",
  });
  return { data: api.data, loading: api.loading, error: api.error, refetch: api.execute };
};

export const useCreateRole = () =>
  useApi(BASE, { method: "POST", errorMessage: "Failed to create role" });

export const useUpdateRole = () => {
  const api = useApi((id) => `${BASE}/${id}`, {
    method: "PUT",
    errorMessage: "Failed to update role",
  });
  const execute = async (id, payload) => {
    if (!id) throw new Error("Role id is required");
    return api.execute(id, payload);
  };
  return { execute, loading: api.loading, error: api.error };
};

export const useDeleteRole = () => {
  const api = useApi((id) => `${BASE}/${id}`, {
    method: "DELETE",
    errorMessage: "Failed to delete role",
  });
  const execute = async (id) => {
    if (!id) throw new Error("Role id is required");
    return api.execute(id);
  };
  return { execute, loading: api.loading, error: api.error };
};
